import _ from 'lodash';
import axios from 'axios';
import * as types from '../constants/ActionTypes';

// Helpers.
import { docTypeOptions } from '../../lib/customFields';
import { trackLink } from '../../lib/analytics-helper';
import Page from '../../lib/page';

const CancelToken = axios.CancelToken;
const source = CancelToken.source();

const SEARCH_ARTICLE_API_URL = '/smarthelp/related-article';

function requestArticleSearch() {
  return {
    type: types.REQUEST_ARTICLE_SEARCH,
    payload: undefined,
  };
}

function receiveArticleSearchResult(searchTerm, experience, responseData, documentType) {
  return {
    type: types.RECEIVE_ARTICLE_SEARCH_RESPONSE,
    payload: {
      q: searchTerm,
      experience,
      items: responseData,
      channel: documentType,
    },
  };
}

function receiveArticleSearchError(searchTerm, experience, documentType) {
  return {
    type: types.RECEIVE_ARTICLE_SEARCH_ERROR,
    payload: {
      q: searchTerm,
      experience,
      channel: documentType,
    },
  };
}

function fetchArticleSearchResult(searchTerm, experience, channel) {
  const documentType = (_.has(docTypeOptions, channel)) ? channel : 'faq';
  const trackLinkOption = {
    id: 'searchPage',
    link: `smarthelp-search-filter-document-type|${documentType}`,
    srch: searchTerm,
  };
  const articleSearchUrl = `${SEARCH_ARTICLE_API_URL}?q=${Page.getSanitizedValue(searchTerm)}&exp=${experience}&channel=${documentType}`;

  return (dispatch) => {
    dispatch(requestArticleSearch());
    return axios.get(articleSearchUrl, {
      cancelToken: source.token,
    })
    .then((response) => {
      trackLink(trackLinkOption);
      dispatch(receiveArticleSearchResult(searchTerm, experience, response.data, documentType));
    })
    .catch(() => {
      trackLink(trackLinkOption);
      dispatch(receiveArticleSearchError(searchTerm, experience, documentType));
    });
  };
}

function cancelArticleSearchRequest() {
  source.cancel('Article Search request canceled.');
}

module.exports = {
  fetchArticleSearchResult,
  cancelArticleSearchRequest,
};



// WEBPACK FOOTER //
// ./contactUs/actions/action-article-search.js